import OmegaTracker from '@didi/omega-tracker'
import Cookies from 'utils/Cookies'
import { SESSION_USER } from 'utils/constants'
let enableDevOmega = false
try {
  if (localStorage.getItem('enableDevOmega')) {
    enableDevOmega = true
  }
} catch (e) {
  console.log('enableDevOmega未引入')
}
const config = {
  appKey: 'omega056c4f2a9f',
  uploadHost: process.env.NODE_ENV === 'production' || enableDevOmega ? 'omgup.didiglobal.com' : '',
  autoClick: false // 全局点击事件监控，如不需要 建议关闭
}

export const omegaInstance = OmegaTracker.getTracker(config)

export class Omega {
  static getBasicAttrs () {
    const userInfo = JSON?.parse(Cookies?.get(SESSION_USER)) || {}
    return {
      user_name: userInfo?.business?.name,
      v3_host: location.host,
      host: location.host,
      os_type: navigator.userAgent,
      os_version: `${process.env.VUE_APP_COMMIT_VERSION?.replace(/[\r\n]/g, '')}\n${
        process.env.VUE_APP_NAME
      }-${process.env.VUE_APP_VERSION}`
    }
  }

  /**
   * 初始化
   */
  static init (userId) {
    console.log(`omega init: ${userId}`)
    omegaInstance.setUserName(userId)
  }

  /**
   * 事件埋点
   */
  static trackEvent (eventId, attrs = {}) {
    try {
      const basicAttrs = Omega.getBasicAttrs() || {}
      omegaInstance.trackEvent(eventId, '', { ...basicAttrs, ...attrs })
    } catch (e) {
      console.log('omega upload error')
    }
  }

  /**
   * 错误上报
   */
  static trackError (name, code, msg, attrs) {
    omegaInstance.trackError(name, code, msg, attrs)
  }
  /**
   * 通用接口异常埋点
   * @param {*} base
   * @param {*} param1
   */
  static traceApiError (
    base,
    { path = '', params = '', status = 200, code = 0, msg = '', traceId = '' }
  ) {
    try {
      const omegaParams = {
        base: base || path || '',
        path,
        params,
        status,
        code,
        msg,
        trace_id: traceId
      }
      // console.log('-----------omegaParams------------')
      // console.log(omegaParams?.base)
      // console.log('-----------omegaParams------------')
      Omega.trackEvent('tech_b2b_v3_api_error', omegaParams)
    } catch (err) {
      console.log('omega上报错误')
    }
  }

  /**
   * 通用业务埋点
   * @param {*} eventId
   * @param {*} param1
   */
  static trackBusiness (eventId, { business, type, status, msg, params }) {
    try {
      const omegaParams = {
        business,
        type,
        status,
        msg,
        params
      }
      Omega.trackEvent(eventId, omegaParams)
    } catch (err) {
      console.log('omega上报错误')
    }
  }

  static hasRefRender = ({ eventId, ref, condition = true, attrs }) => {
    console.log(eventId, ref, condition, attrs, 'hasRefRender')
    try {
      if (condition) {
        if (!ref) {
          console.log('不存在Ref渲染，请进行埋点上报', ref, eventId, attrs)
          Omega.trackEvent(eventId, attrs)
        }
      }
    } catch (e) {
      console.log('hasRefRender error', e)
    }
  };
}

export const OmegaEventIds = {
  tech_b2b_v3_router_en: 'tech_b2b_v3_router_en',
  tech_b2bv3_login_step2_render_error: 'tech_b2bv3_login_step2_render_error',
  tech_b2bv3_login: 'tech_b2bv3_login',
  tech_b2bv3_webcall: 'tech_b2bv3_webcall',
  tech_b2bv3_other: 'tech_b2bv3_other'
}

export const OmegaBusiness = {
  login: 'login',
  webcall: 'webcall',
  employee: 'employee',
  user: 'user',
  addSign: 'addSign',
  api: 'api'
}

export const OmegaStatus = {
  op: 'op', // 操作
  sw: 'sw', // 显示
  en: 'en', // 进入步骤
  cancel: 'cancel', // 取消
  ex: 'ex', // 结束步骤。ex包含退出步骤和成功su
  success: 'success', // 成功
  error: 'error', // 成功
  swError: 'swError' // 渲染失败
}
